export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/extensions/acl/AccessControl.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/empty1',
    name: 'empty1',
    component: () => import('@/views/pages/Empty.vue'),
  },
  {
    path: '/empty2',
    name: 'empty2',
    component: () => import('@/views/pages/Empty.vue'),
  },
]
